import { render, staticRenderFns } from "./viewInfoHistoricoFD.vue?vue&type=template&id=7924f2d7&scoped=true"
import script from "./viewInfoHistoricoFD.vue?vue&type=script&lang=js"
export * from "./viewInfoHistoricoFD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924f2d7",
  null
  
)

export default component.exports